var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66953 12.9144L11.7317 8.77133C13.711 6.09327 14.7007 4.75425 15.6241 5.03721C16.5474 5.32018 16.5474 6.96249 16.5474 10.2471V10.5568C16.5474 11.7415 16.5474 12.3339 16.926 12.7054L16.946 12.7247C17.3327 13.0884 17.9492 13.0884 19.1822 13.0884C21.4011 13.0884 22.5106 13.0884 22.8855 13.7613C22.8917 13.7724 22.8977 13.7837 22.9036 13.795C23.2576 14.4784 22.6152 15.3475 21.3304 17.0857L18.2683 21.2287C16.2889 23.9067 15.2992 25.2458 14.3758 24.9628C13.4525 24.6798 13.4525 23.0375 13.4525 19.7528L13.4526 19.4433C13.4526 18.2585 13.4526 17.6662 13.074 17.2946L13.054 17.2754C12.6673 16.9117 12.0508 16.9117 10.8178 16.9117C8.59888 16.9117 7.48945 16.9117 7.1145 16.2387C7.10829 16.2276 7.10225 16.2164 7.09639 16.205C6.74244 15.5217 7.3848 14.6526 8.66953 12.9144Z",
    fill: "#8E092E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/Bolt.f6dda1fc8c42edae00f9d83ed620873c.svg";
export { ForwardRef as ReactComponent };